module.exports = __webpack_public_path__ + "static/media/yellow-old-paper.66d3ad46.jpg";